import { Favorite } from '@models';

export interface AuthSession {
  authToken: string;
  avatarUrl: string;
  expiresAt: number;
  subject: string;
  username: string;
  firstName: string;
  lastName: string;
  email: string;
  favorites?: Favorite[];
}
